import { FormatDateOptions } from "react-intl";

export const defaultSupportDueDateDiff = 7;
export const defaultProfileRoutineDueDateDiff = 3;
export const defaultSalaryDeviationReportDueDateDiff = 5;

export const MonthYearLongConfig: FormatDateOptions = {
  month: "long",
  year: "numeric",
};

export const MonthYearShortConfig: FormatDateOptions = {
  month: "short",
  year: "numeric",
};

export const MonthYearNumericConfig: FormatDateOptions = {
  month: "numeric",
  year: "numeric",
};

export const DateMonthLongConfig: FormatDateOptions = {
  day: "numeric",
  month: "short",
};

export const DateFullMonthConfig: FormatDateOptions = {
  day: "numeric",
  month: "long",
};

export const DateMonthYearShortConfig: FormatDateOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
};

export const MonthShortConfig: FormatDateOptions = {
  month: "short",
};

export const MonthLongConfig: FormatDateOptions = {
  month: "long",
};

export const DateDayTimeConfig: FormatDateOptions = {
  weekday: "short",
  hour: "numeric",
  minute: "numeric",
};

export const DateTimeConfig: FormatDateOptions = {
  day: "numeric",
  month: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
};

export const FullWeekStartWithSunday = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
export const FullWeekStartWithMonday = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
export const TotalDaysOfWeek = 7;
